import React, { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { formatDate } from "@/lib/format";
import { Loading, EmptyState, Modal } from "@/components/kit";
import { Check, Users, CalendarClock } from "lucide-react";

export default function CoachClasses() {
  const [classes, setClasses] = useState(null);
  const [busy, setBusy] = useState("");
  const [roster, setRoster] = useState(null);

  const load = useCallback(async () => {
    try { setClasses(await api.coachClasses()); } catch (e) { toast.error(e.message); setClasses([]); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const checkin = async (c) => {
    setBusy(c.id);
    try { await api.coachCheckin(c.name, c.date, c.time, c.id); toast.success("Check-in tercatat"); load(); }
    catch (e) { toast.error(e.message); } finally { setBusy(""); }
  };

  const viewRoster = async (c) => {
    try { setRoster({ ...(await api.coachRoster(c.name, c.date, c.start)), title: c.name }); }
    catch (e) { toast.error(e.message); }
  };

  return (
    <div className="space-y-5 fade-in">
      <div>
        <div className="hsc-label">Coach</div>
        <h1 className="font-display text-3xl text-white">Kelas Saya</h1>
      </div>

      {classes === null ? <Loading /> : !classes.length ? (
        <EmptyState icon={CalendarClock} title="Belum ada kelas terjadwal" />
      ) : (
        <div className="space-y-3">
          {classes.map((c) => (
            <div key={c.id} className="rounded-2xl border border-[#1F1F22] bg-[#0A0A0C] p-4" data-testid="coach-class">
              <div className="flex items-start justify-between">
                <div>
                  <div className="text-white">{c.name}</div>
                  <div className="mt-1 text-[12px] text-[#8E8E93]">{formatDate(c.date)} · {c.time}</div>
                  <button onClick={() => viewRoster(c)} className="mt-2 inline-flex items-center gap-1 text-[12px] text-[#8FD3E8]">
                    <Users className="h-3.5 w-3.5" /> {c.participants_today} peserta
                  </button>
                </div>
                <button disabled={c.coach_checked_in || busy === c.id} onClick={() => checkin(c)} data-testid="coach-checkin"
                  className={`rounded-full px-4 py-2 text-[12px] font-semibold ${c.coach_checked_in ? "border border-[#2C2C2E] text-[#7CD992]" : "bg-white text-black"}`}>
                  {c.coach_checked_in ? <><Check className="mr-1 inline h-3.5 w-3.5" />Hadir</> : "Check-in"}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <Modal open={!!roster} onClose={() => setRoster(null)} title={roster?.title}>
        {!roster?.roster?.length ? <div className="text-sm text-[#6E6E73]">Belum ada peserta.</div> : (
          <div className="max-h-80 space-y-2 overflow-y-auto">
            {roster.roster.map((r, i) => (
              <div key={i} className="flex items-center justify-between rounded-lg border border-[#141416] px-3 py-2 text-sm">
                <span className="text-white">{r.member_name}</span>
                <span className={`text-[11px] ${r.checked_in_at ? "text-[#7CD992]" : "text-[#6E6E73]"}`}>{r.checked_in_at ? "Hadir" : "Belum"}</span>
              </div>
            ))}
          </div>
        )}
      </Modal>
    </div>
  );
}
